// extracted by mini-css-extract-plugin
export var quantityInput = "_fm-0";